import { render, staticRenderFns } from "./trsFooter.vue?vue&type=template&id=1e9befb6&scoped=true"
import script from "./trsFooter.vue?vue&type=script&lang=js"
export * from "./trsFooter.vue?vue&type=script&lang=js"
import style0 from "./trsFooter.vue?vue&type=style&index=0&id=1e9befb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9befb6",
  null
  
)

export default component.exports